/**
 * EVIVA GAMBLE — header scroll behavior
 *
 * Toggles .eviva-header--scrolled on #header-component when scrollY > 24px,
 * matching the Next.js SiteHeader transparent → blurred transition.
 */
(function () {
  const SCROLL_THRESHOLD = 24;
  const header = document.getElementById('header-component');

  if (!header) return;

  function updateScrollState() {
    header.classList.toggle('eviva-header--scrolled', window.scrollY > SCROLL_THRESHOLD);
  }

  updateScrollState();
  window.addEventListener('scroll', updateScrollState, { passive: true });
})();
